import React, { Component } from 'react';
import NavBar from './NavBar'

export default class NotFound extends Component {

    render(){
        return (
            <div>
                <NavBar />
                <main className='container'>
                    <h2>Not found - 404</h2>
                    <p>The thing you're looking for doesn't exist!</p>
                </main>
            </div>
        );
    }

}





/** WEBPACK FOOTER **
 ** ./src/components/NotFound.js
 **/